import { render, staticRenderFns } from "./TeamValidate.vue?vue&type=template&id=2aaeb8da"
import script from "./TeamValidate.vue?vue&type=script&lang=js"
export * from "./TeamValidate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports